export const LeadCalculationConstants = { 
    REQUEST_FOUNDATION_CALCULATION_SUCCESS: 'REQUEST_FOUNDATION_CALCULATION_SUCCESS',
    REQUEST_FOUNDATION_CALCULATION_FAIL: 'REQUEST_FOUNDATION_CALCULATION_FAIL'
}